import { isSumaho } from '../common/isSumaho';

export function tn() {
  if (isSumaho()) {
    $('.tn-bx').append($('.tn-btn'));
  }
}
